import React from 'react'
import { Route, Redirect } from 'react-router'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { getLandingRoute, hasMenuAccess } from '../config/menuAccess'

export class PrivateRoute extends React.Component {
  render () {
    const Component = this.props.component
    const menuId = this.props.menuId
    const rest = { ...this.props }
    delete rest.component
    delete rest.menuId

    return (
      <Route {...rest} render={props => {
        if (!this.props?.auth?.user) {
          return (
            <span>
              <Redirect to={{
                pathname: '/login',
                state: { from: props.location }
              }} />
            </span>
          )
        }

        // Role-gate the route when a menuId is provided. If the user's role has
        // no access to that menu, bounce them to their landing route.
        if (menuId) {
          const roles = this.props.auth.user?.data?.role || []
          if (!hasMenuAccess(roles, menuId)) {
            const landing = getLandingRoute(roles)
            if (landing !== props.location.pathname) {
              return <Redirect to={landing} />
            }
          }
        }

        return <Component {...props} />
      }} />
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

function mapDispatchToProps (dispatch) {
  return {}
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute))
